import { useState } from "react";
import {
  FormControl,
  MenuItem,
  InputAdornment,
  IconButton,
  Box,
  Divider,
  TextField,
  Menu,
} from "@mui/material";
import InsertInvitationIcon from "@mui/icons-material/InsertInvitation";
import ClearIcon from "@mui/icons-material/Clear";
import CommonDatePicker from "./CommonDatePicker";
import { useSelector } from "react-redux";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const formatDate = (date) => {
  return date
    ? `${date.getFullYear()}-${("0" + (date.getMonth() + 1)).slice(-2)}-${(
        "0" + date.getDate()
      ).slice(-2)}`
    : "";
};

const DateRangeFilterDropdown = ({
  value,
  onChange,
//   maxRange = 45,
  maxDate = new Date(),
}) => {
  const today = new Date();
  const { minDojYear } = useSelector(
    (state) => state?.AncillaryReducer?.WorkSpaceDojReducer,
  );
  const [selected, setSelected] = useState(value?.option || "");
  const [showCustom, setShowCustom] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleOpen = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handlePreset = (option) => {
    let from, to;

    if (option === "Custom Range") {
      setShowCustom(true);
      setSelected(option);
      return;
    }

    setShowCustom(false);
    setSelected(option);

    switch (option) {
      case "Today":
        from = to = today;
        break;

      case "Yesterday":
        const y = new Date();
        y.setDate(today.getDate() - 1);
        from = to = y;
        break;

      case "Last 7 days":
        const l7 = new Date();
        l7.setDate(today.getDate() - 6);
        from = l7;
        to = today;
        break;

      case "Last 30 days":
        const l30 = new Date();
        l30.setDate(today.getDate() - 29);
        from = l30;
        to = today;
        break;

      default:
        return;
    }

    onChange({
      from_date: formatDate(from),
      to_date: formatDate(to),
      option,
    });
    setAnchorEl(null);
  };

  const handleCustomChange = (type, date) => {
    const formatted = formatDate(date);

    let newFrom = value?.from_date;
    let newTo = value?.to_date;

    if (type === "from") {
      newFrom = formatted;

      // uncomment: enforce max range
    //   if (newTo) {
    //     const diff =
    //       (new Date(newTo) - new Date(newFrom)) / (1000 * 60 * 60 * 24);

    //     if (diff > maxRange) {
    //       const temp = new Date(newFrom);
    //       temp.setDate(temp.getDate() + maxRange);
    //       newTo = formatDate(temp);
    //     }
    //   }
    }

    if (type === "to") {
      newTo = formatted;

    //   if (newFrom) {
    //     const diff =
    //       (new Date(newTo) - new Date(newFrom)) / (1000 * 60 * 60 * 24);

    //     if (diff > maxRange) {
    //       const temp = new Date(newTo);
    //       temp.setDate(temp.getDate() - maxRange);
    //       newFrom = formatDate(temp);
    //     }
    //   }
    }

    onChange({
      from_date: newFrom,
      to_date: newTo,
      option: "Custom Range",
    });
  };

  const handleClear = () => {
    setSelected("Today");
    setShowCustom(false);
    onChange({
      from_date: formatDate(today),
      to_date: formatDate(today),
      option: "Today",
    });
  };

  return (
    <FormControl fullWidth size="small">
      <TextField
        fullWidth
        size="small"
        onClick={handleOpen}
        value={selected || "Date"}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <InsertInvitationIcon />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              {selected && selected !== "Today" ? (
                <IconButton
                    size="small"
                    onClick={(e) => {
                    e.stopPropagation(); 
                    handleClear();
                    }}
                    sx={{ mr: 0.5 }}
                >
                    <ClearIcon fontSize="small" />
                </IconButton>
                ) : (
                    <ArrowDropDownIcon sx={{ fontSize: 22, color: "action.active" }} />
                )}
            </InputAdornment>
          ),
        }}
      />
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose} 
      PaperProps={{
            sx: {
            minWidth: 250,
            mt: 0.5,
            },
        }}>
        <MenuItem onClick={() => handlePreset("Today")}>Today</MenuItem>
        <MenuItem onClick={() => handlePreset("Yesterday")}>Yesterday</MenuItem>
        <MenuItem onClick={() => handlePreset("Last 7 days")}>Last 7 days</MenuItem>
        <MenuItem onClick={() => handlePreset("Last 30 days")}>Last 30 days</MenuItem>

        <MenuItem
          onClick={(e) => {
            e.stopPropagation();
            setShowCustom(true);
            setSelected("Custom Range");
          }}
        >
          Custom Range
        </MenuItem>

        {showCustom && (
          <>
            <Divider sx={{ my: 1 }} />
            <Box
              sx={{ px: 2, py: 1, display: "flex", gap: 1 }}
              onClick={(e) => e.stopPropagation()}
            >
              <CommonDatePicker
                name="from"
                label={"From Date"}
                size="small"
                pickerType="date"
                pickerFormat="dd/MM/yyyy"
                DefaultDTvalue={value?.from_date}
                minDate={
                  new Date(
                    new Date(minDojYear).setFullYear(
                      new Date(minDojYear).getFullYear() - 1,
                    ),
                  )
                }
                maxDate={maxDate}
                handleChange={(val) => handleCustomChange("from", val)}
              />

              <CommonDatePicker
                name="to"
                label={"To Date"}
                size="small"
                pickerType="date"
                pickerFormat="dd/MM/yyyy"
                DefaultDTvalue={value?.to_date}
                minDate={value?.from_date}
                maxDate={maxDate}
                handleChange={(val) => handleCustomChange("to", val)}
              />
            </Box>
          </>
        )}
      </Menu>
    </FormControl>
  );
};

export default DateRangeFilterDropdown;
